export default "__VITE_ASSET__o901yQax__"